import { ISocialMedia, ISocialMediaItem } from '@features/cms/typescript';
import SocialMediaItem from '@components/SocialMedia/SocialMediaItem';
import styles from '@components/SocialMedia/SocialMedia.styles';
import theme from '@styles/theme';
import Heading from '@components/Heading/Heading';
type PropsType = {
  socialMedia: ISocialMedia;
  isFirst: boolean;
};
const SocialMedia = ({
  socialMedia,
  isFirst
}: PropsType) => {
  const {
    header,
    headerColor,
    items
  } = socialMedia;
  if (items.length === 0) {
    return null;
  }
  return <div sx={styles.socialMediaContainer} data-testid="SocialMediaContainer">
      <Heading h={isFirst ? 1 : 2} display={3} mobile align="center" color={headerColor || theme.rawColors.darkGrey700}>
        {header}
      </Heading>

      <div sx={styles.socialMediaItemsContainer} data-testid="SocialMediaItemsContainer">
        <div sx={styles.socialMediaPartContainer} data-testid="SocialMediaPartContainer">
          {items.slice(0, 2).map((mediaItem: ISocialMediaItem) => <SocialMediaItem key={mediaItem.itemId} mediaItem={mediaItem} />)}
        </div>
        <div sx={styles.socialMediaPartContainer} data-testid="SocialMediaPartContainer">
          {items.slice(2, 4).map((mediaItem: ISocialMediaItem) => <SocialMediaItem key={mediaItem.itemId} mediaItem={mediaItem} />)}
        </div>
      </div>
    </div>;
};
export default SocialMedia;